import { Home } from "@mui/icons-material"
import { Button, IconButton } from "@mui/material"

export const Header = (props: any) => {
    return (
        <div style={{ padding: '4px', alignItems: 'center', display: 'flex' }}>
            {/*header*/}
            <IconButton onClick={() => props.onNavigate?.('/')} size="small">
                <Home fontSize="inherit" />
            </IconButton>
            {props.chain?.map((link, ix) => {
                return <div style={{display: 'flex', alignItems: 'center'}} key={`chain-${ix}`}>
                    <Button 
                        onClick={() => props.onNavigate?.('/' + props.chain?.slice(0, ix +1).join('/'))}
                        size="small" 
                        sx={{color: 'black', fontWeight: 'normal', textTransform: 'none'}}>{link}</Button>
                    <div>/</div>
                </div>
            })}
        </div>
    )
}